'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _debouncer = require('./debouncer');

var _debouncer2 = _interopRequireDefault(_debouncer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Helper function for normalizing tolerance option to object format
 */
function normalizeTolerance(t) {
  return t === Object(t) ? t : { down: t, up: t };
}

var initialState = {
  pinned: false,
  unpinned: false,
  top: false,
  notTop: false,
  bottom: false,
  notBottom: false,
  initial: false
};

var Headroom = function (_Component) {
  _inherits(Headroom, _Component);

  function Headroom(props) {
    _classCallCheck(this, Headroom);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Headroom).call(this, props));

    _this.state = {
      initialised: false,
      lastKnownScrollY: 0,
      classes: initialState
    };
    _this.scroller = null;
    _this.debouncer = null;
    _this.classes = _this.props.classes;
    _this.tolerance = normalizeTolerance(_this.props.tolerance);
    _this.update = _this.update.bind(_this);
    _this.attachEvent = _this.attachEvent.bind(_this);
    return _this;
  }

  _createClass(Headroom, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        classes: _extends({}, this.state.classes, {
          initial: true
        })
      });
      this.scroller = this.props.scroller || window;
      this.debouncer = new _debouncer2.default(this.update);
      setTimeout(this.attachEvent, 100);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({
        initialised: false,
        classes: initialState
      });
      this.scroller.removeEventListener('scroll', this.debouncer, false);
    }
    /**
     * Attaches the scroll event
     * @private
     */

  }, {
    key: 'attachEvent',
    value: function attachEvent() {
      if (!this.initialised) {
        this.setState({
          initialised: true,
          lastKnownScrollY: this.getScrollY()
        });
        this.scroller.addEventListener('scroll', this.debouncer, false);
        this.debouncer.handleEvent();
      }
    }
    /**
     * Unpins the header if it's currently pinned
     */

  }, {
    key: 'unpin',
    value: function unpin() {
      var classList = this.state.classes;
      if (classList.pinned || !classList.unpinned) {
        this.setState({
          classes: _extends({}, classList, {
            unpinned: true,
            pinned: false
          })
        });
        this.props.onUnpin && this.props.onUnpin.apply(this);
      }
    }
    /**
     * Pins the header if it's currently unpinned
     */

  }, {
    key: 'pin',
    value: function pin() {
      var classList = this.state.classes;

      if (classList.unpinned) {
        this.setState({
          classes: _extends({}, classList, {
            pinned: true,
            unpinned: false
          })
        });
        this.props.onPin && this.props.onPin.apply(this);
      }
    }
    /**
    * Handles the top states
    */

  }, {
    key: 'top',
    value: function top() {
      var classList = this.state.classes;
      if (!classList.top) {
        this.setState({
          classes: _extends({}, classList, {
            top: true,
            notTop: false
          })
        });
        this.props.onTop && this.props.onTop.apply(this);
      }
    }
    /**
     * Handles the not top state
     */

  }, {
    key: 'notTop',
    value: function notTop() {
      var classList = this.state.classes;
      if (!classList.notTop) {
        this.setState({
          classes: _extends({}, classList, {
            notTop: true,
            top: false
          })
        });
        this.props.onNotTop && this.props.onNotTop.apply(this);
      }
    }
  }, {
    key: 'bottom',
    value: function bottom() {
      var classList = this.state.classes;
      if (!classList.bottom) {
        this.setState({
          classes: _extends({}, classList, {
            bottom: true,
            notBottom: false
          })
        });
        this.props.onBottom && this.props.onBottom.apply(this);
      }
    }
    /**
     * Handles the not top state
     */

  }, {
    key: 'notBottom',
    value: function notBottom() {
      var classList = this.state.classes;
      if (!classList.notBottom) {
        this.setState({
          classes: _extends({}, classList, {
            notBottom: true,
            bottom: false
          })
        });
        this.props.onNotBottom && this.props.onNotBottom.apply(this);
      }
    }
    /**
    * Gets the Y scroll position
    * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY
    * @return {Number} pixels the page has scrolled along the Y-axis
    */

  }, {
    key: 'getScrollY',
    value: function getScrollY() {
      return this.scroller.pageYOffset !== undefined ? this.scroller.pageYOffset : this.scroller.scrollTop !== undefined ? this.scroller.scrollTop : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    }
    /**
     * Gets the height of the viewport
     * @see http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript
     * @return {int} the height of the viewport in pixels
     */

  }, {
    key: 'getViewportHeight',
    value: function getViewportHeight() {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }
    /**
     * Gets the physical height of the DOM element
     * @param  {Object}  elm the element to calculate the physical height of which
     * @return {int}     the physical height of the element in pixels
     */

  }, {
    key: 'getElementPhysicalHeight',
    value: function getElementPhysicalHeight(elm) {
      return Math.max(elm.offsetHeight, elm.clientHeight);
    }
    /**
     * Gets the physical height of the scroller element
     * @return {int} the physical height of the scroller element in pixels
     */

  }, {
    key: 'getScrollerPhysicalHeight',
    value: function getScrollerPhysicalHeight() {
      return this.scroller === window || this.scroller === document.body ? this.getViewportHeight() : this.getElementPhysicalHeight(this.scroller);
    }
    /**
     * Gets the height of the DOM element
     * @param  {Object}  elm the element to calculate the height of which
     * @return {int}     the height of the element in pixels
     */

  }, {
    key: 'getElementHeight',
    value: function getElementHeight(elm) {
      return Math.max(elm.scrollHeight, elm.offsetHeight, elm.clientHeight);
    }
    /**
     * Gets the height of the document
     * @see http://james.padolsey.com/javascript/get-document-height-cross-browser/
     * @return {int} the height of the document in pixels
     */

  }, {
    key: 'getDocumentHeight',
    value: function getDocumentHeight() {
      var body = document.body;
      var documentElement = document.documentElement;

      return Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight, body.clientHeight, documentElement.clientHeight);
    }

    /**
     * Gets the height of the scroller element
     * @return {int} the height of the scroller element in pixels
     */

  }, {
    key: 'getScrollerHeight',
    value: function getScrollerHeight() {
      return this.scroller === window || this.scroller === document.body ? this.getDocumentHeight() : this.getElementHeight(this.scroller);
    }
    /**
     * determines if the scroll position is outside of document boundaries
     * @param  {int}  currentScrollY the current y scroll position
     * @return {bool} true if out of bounds, false otherwise
     */

  }, {
    key: 'isOutOfBounds',
    value: function isOutOfBounds(currentScrollY) {
      var pastTop = currentScrollY < 0;
      var pastBottom = currentScrollY + this.getScrollerPhysicalHeight() > this.getScrollerHeight();

      return pastTop || pastBottom;
    }
    /**
     * determines if the tolerance has been exceeded
     * @param  {int} currentScrollY the current scroll y position
     * @return {bool} true if tolerance exceeded, false otherwise
     */

  }, {
    key: 'toleranceExceeded',
    value: function toleranceExceeded(currentScrollY, direction) {
      return Math.abs(currentScrollY - this.state.lastKnownScrollY) >= this.tolerance[direction];
    }
    /**
     * determine if it is appropriate to unpin
     * @param  {int} currentScrollY the current y scroll position
     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
     * @return {bool} true if should unpin, false otherwise
     */

  }, {
    key: 'shouldUnpin',
    value: function shouldUnpin(currentScrollY, toleranceExceeded) {
      var scrollingDown = currentScrollY > this.state.lastKnownScrollY;
      var pastOffset = currentScrollY >= this.props.offset;

      return scrollingDown && pastOffset && toleranceExceeded;
    }
    /**
     * determine if it is appropriate to pin
     * @param  {int} currentScrollY the current y scroll position
     * @param  {bool} toleranceExceeded has the tolerance been exceeded?
     * @return {bool} true if should pin, false otherwise
     */

  }, {
    key: 'shouldPin',
    value: function shouldPin(currentScrollY, toleranceExceeded) {
      var scrollingUp = currentScrollY < this.state.lastKnownScrollY;
      var pastOffset = currentScrollY <= this.props.offset;

      return scrollingUp && toleranceExceeded || pastOffset;
    }
  }, {
    key: 'update',
    value: function update() {
      var currentScrollY = this.getScrollY();
      var scrollDirection = currentScrollY > this.state.lastKnownScrollY ? 'down' : 'up';
      var toleranceExceeded = this.toleranceExceeded(currentScrollY, scrollDirection);
      // Ignore bouncy scrolling in OSX
      if (this.isOutOfBounds(currentScrollY)) {
        return;
      }
      if (currentScrollY <= this.props.offset) {
        this.top();
      } else {
        this.notTop();
      }

      if (currentScrollY + this.getViewportHeight() >= this.getScrollerHeight()) {
        this.bottom();
      } else {
        this.notBottom();
      }

      if (this.shouldUnpin(currentScrollY, toleranceExceeded)) {
        this.unpin();
      } else if (this.shouldPin(currentScrollY, toleranceExceeded)) {
        this.pin();
      }

      this.setState({
        lastKnownScrollY: currentScrollY
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.disable()) return this.props.children;
      var cNames = this.props.classes;
      var sNames = this.state.classes;
      var t = {};
      Object.keys(cNames).map(function (k) {
        t[cNames[k]] = sNames[k];
      });
      var cName = (0, _classnames2.default)(t);
      var children = _react2.default.cloneElement(this.props.children, {
        className: cName + ' ' + this.props.children.props.className
      });
      return children;
    }
  }]);

  return Headroom;
}(_react.Component);

Headroom.propTypes = {
  children: _react.PropTypes.element.isRequired,
  classes: _react.PropTypes.object,
  scroller: _react.PropTypes.object,
  tolerance: _react.PropTypes.any,
  offset: _react.PropTypes.number,
  onNotBottom: _react.PropTypes.func,
  onBottom: _react.PropTypes.func,
  onNotTop: _react.PropTypes.func,
  onTop: _react.PropTypes.func,
  onUnpin: _react.PropTypes.func,
  onPin: _react.PropTypes.func,
  disable: _react.PropTypes.func
};
Headroom.defaultProps = {
  classes: {
    pinned: 'headroom--pinned',
    unpinned: 'headroom--unpinned',
    top: 'headroom--top',
    notTop: 'headroom--not-top',
    initial: 'headroom'
  },
  tolerance: {
    up: 0,
    down: 0
  },
  offset: 0,
  disable: function disable() {
    return false;
  }
};

exports.default = Headroom;


//////////////////
// WEBPACK FOOTER
// ./~/react-headrooms/lib/index.js
// module id = 960
// module chunks = 0 1